export default __webpack_public_path__ + "static/Bracket_new_-IN-5907-cc67939be4672401004937650e3e2206.jpg";